import { render, staticRenderFns } from "./RefundDialog.vue?vue&type=template&id=4225cf9d&scoped=true&"
import script from "./RefundDialog.vue?vue&type=script&lang=js&"
export * from "./RefundDialog.vue?vue&type=script&lang=js&"
import style0 from "./RefundDialog.vue?vue&type=style&index=0&id=4225cf9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4225cf9d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2983364112/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4225cf9d')) {
      api.createRecord('4225cf9d', component.options)
    } else {
      api.reload('4225cf9d', component.options)
    }
    module.hot.accept("./RefundDialog.vue?vue&type=template&id=4225cf9d&scoped=true&", function () {
      api.rerender('4225cf9d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/OrderWidget/Refund/RefundDialog.vue"
export default component.exports